import React, { useEffect, useState } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { withSocket } from "../../../socket/context";
import { compose } from "redux";
import { removeUser } from "../../shared/utils";
import cx from "classnames";
import userSmall from "../../../assets/images/sbs/user-small.png";
import userBig from "../../../assets/images/sbs/user-big.png";
import redCrossIcon from "../../../assets/images/sbs/red-cross.png";
import userIcon from "../../../assets/images/sbs/user1.png";
import award2 from "../../../assets/images/sbs/award-2.png";
import award3 from "../../../assets/images/sbs/award3.png";
import awardIcon from "../../../assets/images/sbs/award.png";
import dummyAvatar from "../../../assets/images/sbs/dummyAvatar.png";

const LeaderBoard = (props) => {
  const users = _.get(props, "gameReducer.roomObj.users");
  const players = _.get(props, "gameReducer.roomObj.game_state.player");
  const [userData, setUserData] = useState([]);
  const [usersLength, setusersLength] = useState();
  const delPlayer = (data) => {
    const roomObj = props.gameReducer.roomObj;
    removeUser(roomObj, data);
  };
  //   useEffect(() => {
  //     if (users && users.length > 0 && players && players.length > 0) {
  //       const userss = users?.map((item) => {
  //         for (let i of players) {
  //           if (i.player_id === item.player_id) {
  //             console.log("firstfirstfirstfirstfirstfirst");
  //             return { ...item, score: i.score };
  //           }
  //         }
  //       });
  //       setUserData(userss);
  //       console.log(userss, "sacasacsacascsacascsac");
  //     }
  //   }, [players]);

  // useEffect(() => {
  //   let usersArray = [];
  //   console.log(usersArray, "usersArrayusersArrayusersArray");
  //   let scores_array = [...player_scores];
  //   scores_array.sort((a, b) =>
  //     a.player_id > b.player_id ? 1 : b.player_id > a.player_id ? -1 : 0
  //   );

  //   for (let i = usersArray.length; i < users.length; i++) {
  //     usersArray = [
  //       ...usersArray,
  //       {
  //         ...scores_array[i],
  //         display_name: users[i].display_name,
  //         profile_image: users[i].profile_image,
  //       },
  //     ];
  //   }
  //   if (player_guesses.length !== 0) {
  //     for (let i = 0; i < player_guesses.length; i++) {
  //       usersArray = [
  //         ...usersArray.map((user) => {
  //           if (player_guesses[i].player_id === user.player_id) {
  //             return { ...user, guess: true };
  //           } else {
  //             return user;
  //           }
  //         }),
  //       ];
  //     }
  //   }
  //   usersArray = usersArray?.sort((a, b) =>
  //     a.score < b.score ? 1 : b.score < a.score ? -1 : 0
  //   );
  //   for (let i = 0; i < usersArray.length; i++) {
  //     if (i === 0) {
  //       usersArray[i].rank = 1;
  //     } else {
  //       if (usersArray[i].score === usersArray[i - 1].score) {
  //         usersArray[i].rank = usersArray[i - 1].rank;
  //       } else {
  //         usersArray[i].rank = i + 1;
  //       }
  //     }
  //   }
  //   setUserData(usersArray);
  // }, [player_scores, player_guesses]);

  useEffect(() => {
    let tempuserss = [];
    let usersArray = [];
    if (users && users.length > 0 && players && players.length > 0) {
      const userss = users?.map((item) => {
        for (let i of players) {
          if (i.player_id === item.player_id) {
            return { ...item, score: i.score };
          }
        }
      });
      tempuserss = userss;
    }
    // usersArray = tempuserss;

    tempuserss = tempuserss?.sort((a, b) =>
      a.score < b.score ? 1 : b.score < a.score ? -1 : 0
    );
    for (let i = 0; i < tempuserss.length; i++) {
      if (i === 0) {
        tempuserss[i].rank = 1;
      } else {
        if (tempuserss[i].score === tempuserss[i - 1].score) {
          tempuserss[i].rank = tempuserss[i - 1].rank;
        } else {
          tempuserss[i].rank = i + 1;
        }
      }
    }

    if (tempuserss && tempuserss.length > 0 && players && players.length > 0) {
      const finalUsersArray = tempuserss?.map((item) => {
        for (let i of players) {
          if (i.player_id === item.player_id) {
            if (i.hasOwnProperty("answer")) {
              return { ...item, highlight: true };
            }
          }
        }
        return { ...item, highlight: false };
      });
      const orderedArray = _.sortBy(finalUsersArray, (o) => o.score);
      orderedArray.reverse();
      setUserData(orderedArray);
    } else {
      const finalUsersArray = users?.map((elem) => {
        return { ...elem, highlight: false };
      });
      const orderedArray = _.sortBy(finalUsersArray, (o) => o.score);
      orderedArray.reverse();
      setUserData(orderedArray);
    }
  }, [players, users]);



  return (
    <div className="small-bites-leaderboard-card">
      <h1 className="title">leaderboard</h1>
      <div className="leaderboard-players">
        {userData &&
          userData.length > 0 &&
          userData?.map((user, index) => (
            <div
              className={cx("player-card", {
                active: !!user?.highlight,
              })}
             >
              <div className="player-info">
                {user?.rank === 1 ? (
                  <img src={awardIcon} className="award-icon" alt="award1" />
                ) : user?.rank === 2 ? (
                  <img src={award2} className="award-icon" alt="award2" />
                ) : user?.rank === 3 ? (
                  <img src={award3} className="award-icon" alt="award3" />
                ) : (
                  <div className="sorted-num">
                    <p className="num">{index + 1}</p>
                  </div>
                )}
                <img
                  src={
                    user?.profile_image !== "profileImage"
                      ? user?.profile_image
                      : dummyAvatar
                  }
                  className="user-icon"
                  alt=""
                />
                <p className="name"> {user?.display_name}</p>
              </div>
              <div className="player-points">
                <p className="pts">{user.score}</p>
                <img
                  src={redCrossIcon}
                  onClick={() => delPlayer(user)}
                  alt=""
                />
              </div>
            </div>
          ))}
        {/* <div className="player-card active">
          <div className="player-info">
            <img src={awardIcon} alt="" />
            <img src={userIcon} className="user-icon" alt="" />
            <p className="name">Giovanni Hernandez</p>
          </div>
          <div className="player-points">
            <p className="pts">123 pts</p>
            <img src={redCrossIcon} alt="" />
          </div>
        </div> */}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
});

export default compose(withSocket, connect(mapStateToProps, null))(LeaderBoard);
